import { ready } from 'core-utilities';
import React from 'react';
import { render } from 'react-dom';
import App from './App';

import { ROOT_ELEMENT_ID } from './utils/constants';

ready(() => {
  render(<App />, document.getElementById(ROOT_ELEMENT_ID));
});
